/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { VatRequest, VatResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiVatController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-vat-controller
   * @name UpdateVat1
   * @request PUT:/api/v1/organisation/vat
   */
  updateVat = (data: VatRequest, params: RequestParams = {}) =>
    this.http.request<VatResponse, any>({
      path: `/v1/organisation/vat`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateVatPath = '/v1/organisation/vat'
  static updateVatMethod = 'PUT'
}
